import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Loader } from './common/components/Loader';
import { getJoinViaReferralToSignupPath } from './common/routes';

export const JoinApp = () => {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const referralId = searchParams.get('via');
    const path = getJoinViaReferralToSignupPath(referralId || '');
    window.location.href = path;
  }, [searchParams]);

  return <Loader />;
};
